import React, { FC } from 'react';
import {
  formatAlphaNumericCyrillicPlusDashAndBlank,
  formatFreeText,
} from 'src/front/common/utils/formUtils';
import { FormRow } from 'src/front/components/FormStyles';
import { FormProps } from 'src/front/components/identity/FormProps';
import ExpiredDate from 'src/front/components/identity/Field/ExpiredDate';
import IssueBy from 'src/front/components/identity/Field/IssueBy';
import IssueCountry from 'src/front/components/identity/Field/IssueCountry';
import IssueDate from 'src/front/components/identity/Field/IssueDate';
import SerialNumber from 'src/front/components/identity/Field/SerialNumber';

const PassportForeignCitizen: FC<FormProps> = ({
  formMethods,
  handleDateChange,
  handleTextChange,
  handleCountryChange,
  countries,
}) => {
  return (
    <>
      <FormRow>
        <SerialNumber
          formatter={formatAlphaNumericCyrillicPlusDashAndBlank}
          formMethods={formMethods}
          max={9}
          min={0}
          onChangeHandler={handleTextChange}
        />
      </FormRow>
      <FormRow>
        <IssueDate formMethods={formMethods} onChangeHandler={handleDateChange} />
        <ExpiredDate formMethods={formMethods} onChangeHandler={handleDateChange} />
      </FormRow>
      <FormRow>
        <IssueBy
          formatter={formatFreeText}
          formMethods={formMethods}
          max={200}
          min={1}
          onChangeHandler={handleTextChange}
        />
        <IssueCountry
          countries={countries}
          formMethods={formMethods}
          onChangeHandler={handleCountryChange}
        />
      </FormRow>
    </>
  );
};

export default PassportForeignCitizen;
